export interface SearchResult {
  icon: string
  name: string
  symbol: string
  denom: string
  price?: string
  change?: number
  chainId: string
}

export function tokenId(item: Pick<SearchResult, 'chainId' | 'denom'>) {
  return `${item.chainId}-${item.denom}`
}
